import * as Yup from "yup";

Yup.addMethod(Yup.mixed, "repeatedThree", function (message) {
  return this.test("repeated-three", message, function (value) {
    const { path, createError } = this;
    let validation = false;
    if (value) {
      let input = value.split("").sort(); //sorting the input
      if (input && input.length === 4 && input[0] < input[1]) {
        let lastVal = input.shift();
        input.push(lastVal);
      }
      input = input.join("");
      let regex = new RegExp(/^(\d)\1{2}/, "g");
      validation = !!input.match(regex);
    }
    return !validation || createError({ path, message });
  });
});

const validationOne = Yup.object().shape({
  personType: Yup.string().required("Este campo es obligatorio"),
  captchaOption: Yup.string().required(),
});

const validationTwo = Yup.object().shape({
  idType: Yup.string().required("Este campo es obligatorio"),
  idNumber: Yup.string()
    .required("Este campo es obligatorio")
    .matches(/^[A-Za-z0-9]+$/, "Este campo es invalido")
    .max(30, "Por favor ingrese un número de documento válido"),
});

const validationRestoreTwo = Yup.object().shape({
  idType: Yup.string().required("Este campo es obligatorio"),
  idNumber: Yup.string()
    .required("Este campo es obligatorio")
    .matches(/^[A-Za-z0-9]+$/, "Este campo es invalido")
    .max(30, "Por favor ingrese un número de documento válido"),

  captchaOption: Yup.string().required(),
});

const validationBasicData1 = Yup.object().shape({
  pin: Yup.string()
    .required("Este campo es obligatorio")
    .min(4, "Sólo se admiten 4 dígitos numéricos")
    .max(4, "Sólo se admiten 4 dígitos numéricos")
    .matches(/^[0-9]+$/, "Debe contener sólo números")
    .matches(/^[1-9]\d*$/, "El código PIN no puede comenzar con cero (0)")
    .matches(
      /^(\d)(?!\1+$)\d*$/,
      "El código pin no puede tener todos los dígitos iguales"
    )
    .matches(
      /^(?!.*1234)(?!.*2345)(?!.*3456)(?!.*4567)(?!.*5678)(?!.*6789)(?!.*9876)(?!.*8765)(?!.*7654)(?!.*6543)(?!.*5432)(?!.*4321)(?!.*3210).*$/,
      "El PIN no puede ser secuencial ascendente ni descendente"
    )
    .repeatedThree("El código pin no puede tener tres dígitos iguales"),
  pinConfirmation: Yup.string()
    .oneOf([Yup.ref("pin")], "El código PIN no coincide")
    .required("Este campo es obligatorio"),

  captchaOption: Yup.string().required(),
});

const validationBasicData = Yup.object().shape({
  email: Yup.string()
    .required("Este campo es obligatorio")
    .matches(
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Ingresa un correo electrónico válido"
    ),
  pin: Yup.string()
    .required("Este campo es obligatorio")
    .min(4, "Sólo se admiten 4 dígitos numéricos")
    .max(4, "Sólo se admiten 4 dígitos numéricos")
    .matches(/^[0-9]+$/, "Debe contener sólo números")
    .matches(/^[1-9]\d*$/, "El código PIN no puede comenzar con cero (0)")
    .matches(
      /^(\d)(?!\1+$)\d*$/,
      "El código pin no puede tener todos los dígitos iguales"
    )
    .matches(
      /^(?!.*1234)(?!.*2345)(?!.*3456)(?!.*4567)(?!.*5678)(?!.*6789)(?!.*9876)(?!.*8765)(?!.*7654)(?!.*6543)(?!.*5432)(?!.*4321)(?!.*3210).*$/,
      "El PIN no puede ser secuencial ascendente ni descendente"
    )
    .repeatedThree("El código pin no puede tener tres dígitos iguales"),
  pinConfirmation: Yup.string()
    .oneOf([Yup.ref("pin")], "El código PIN no coincide")
    .required("Este campo es obligatorio"),
});

const validationBusiness = Yup.object()
  .concat(validationBasicData)
  .shape({
    businessName: Yup.string()
      .required("Este campo es obligatorio")
      .matches(/^[aA-zZ\s]*$/, "Este campo es invalido "),
  });

const validationPerson = Yup.object()
  .concat(validationBasicData)
  .shape({
    firstName: Yup.string()
      .required("Este campo es obligatorio")
      .matches(/^[A-Za-z]+$/, "Este campo es invalido "),
    secondName: Yup.string()
      .nullable()
      .notRequired()
      .matches(/^[A-Za-z]*$/, "Este campo es invalido"),
    firstLastName: Yup.string()
      .required("Este campo es obligatorio")
      .matches(/^[A-Za-z]+$/, "Este campo es invalido"),
    secondLastName: Yup.string()
      .nullable()
      .notRequired()
      .matches(/^[A-Za-z]*$/, "Este campo es invalido"),
  });

const validationRestore = Yup.object()
  .shape({
    captchaOption: Yup.string().required(),
  })
  .concat(validationTwo)
  .concat(validationBasicData);

const defaults = {
  personType: undefined,
  idType: undefined,
  idNumber: undefined,
  businessName: undefined,
  email: undefined,
  pin: undefined,
  pinConfirmation: undefined,
};

const defaults1 = {
  pin: undefined,
  pinConfirmation: undefined,
};

export {
  validationOne,
  validationTwo,
  validationRestoreTwo,
  validationPerson,
  validationBusiness,
  validationRestore,
  validationBasicData1,
  defaults,
  defaults1,
};
